/**
 * "VS Code mssql extension" shortcut scheme (plan D7). Sources, accessed 2026-09-23:
 *
 * [DOCS] https://learn.microsoft.com/en-us/sql/tools/visual-studio-code-extensions/mssql/mssql-keyboard-shortcuts
 *   Microsoft Learn, "Customize keyboard shortcuts" (ms.date 2026-07-10), "MSSQL extension
 *   commands": MS SQL: Execute Query — Ctrl+Shift+E (Windows/Linux), Cmd+Shift+E (macOS).
 *   Execute Selection or Current Statement, Cancel Query and Toggle Query Result Panel: None.
 * [SOURCE] https://github.com/microsoft/vscode-mssql/blob/main/extensions/mssql/package.json
 *   (1.46.0) keybindings: mssql.runQuery key ctrl+shift+e, mac cmd+shift+e.
 *
 * Mapping: Execute Query ("Run a query for the current active SQL document") is Jam's
 * Execute, the command every scheme's execute key maps to; with nothing selected in a
 * one-statement buffer it runs the whole buffer too. The chord is also Jam's global Expand
 * Explorer: Execute takes it in a Query Editor tab and Expand Explorer keeps it everywhere
 * else (scoped-over-global, D6), with the warning on both rows.
 *
 * Left out: every other command, which has no default chord in [DOCS]; the extension's
 * notebook cell binding (not in [DOCS]); the separate "MSSQL Database Management Keymap"
 * (SSMS/ADS-style keys) is what the SSMS / Azure Data Studio scheme follows.
 */
import { defineScheme, onEveryPlatform } from './schemeRows';

export const vscodeMssql = defineScheme('vscode-mssql', 'VS Code mssql extension', [
  // [DOCS] MS SQL: Execute Query: Ctrl+Shift+E / Cmd+Shift+E.
  { commandId: 'query.execute', chords: onEveryPlatform('Mod+Shift+E') },
]);
